<app-floatingconfigurator />

<div
    class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-[100vw] overflow-hidden">
    <div class="flex flex-col items-center justify-center">
        <div
            style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, rgba(247, 149, 48, 0.4) 10%, rgba(247, 149, 48, 0) 30%)">
            <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center"
                style="border-radius: 53px">
                <div class="gap-4 flex flex-col items-center">
                    <div class="flex justify-center items-center border-2 border-orange-500 rounded-full"
                        style="width: 3.2rem; height: 3.2rem">
                        <i class="text-orange-500 pi pi-fw pi-lock !text-2xl"></i>
                    </div>
                    <h1 class="text-surface-900 dark:text-surface-0 font-bold text-4xl lg:text-5xl mb-2">Acceso denegado
                    </h1>
                    <span class="text-muted-color mb-8 text-center">No posee permisos al recurso solicitado. <br>Favor
                        contactese
                        con el
                        administrador.</span>
                    <img src="./assets/img/logos/Avancemos512.png" alt="Access denied" class="mb-8" width="30%" />
                    <div class="col-span-12 mt-8 text-center">
                        <p-button label="Ir al Inicio" (click)="goto('sp')" severity="warn" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>